<template>
    <div class="container">
        example tailwind

        <div class="fixed w-full bottom-0 bg-gray-200">
            <div class="flex p-3">
                <div class="flex">
                    <div class="bg-gray-500 border-4 border-gray-500 w-8 text-center py-2">
                        -
                    </div>
                    <div class="w-8 text-center border-4 border-opacity-0 py-2">
                        5
                    </div>
                    <div class="bg-white border-4 border-red-600 w-8 text-center py-2">
                        +
                    </div>
                </div>
                <div class="flex-grow pl-4">
                    <button class="bg-red-600 text-white w-full p-3">Add to cart</button>
                </div>
            </div>
        </div>
        
        <slide-unlock 
           
                text="Slide to mask used"
                success-text="Used"
                name="slideunlock"
                @completed="complete()"
            />

    </div>
</template>
<script>
import SlideUnlock from "@j2only/slide-unlock"

export default {
    name: 'FooterBottom',
    components: {
        SlideUnlock
    },
    methods: {
        complete: function() {
            console.log('complete');
        }
    }
}
</script>
<!-- <style lang="scss" scoped>
.wrap-code {
    height: 200px;
}
 .slideunlock {
    //width: 214px !important;
    margin: 0 auto;
    border: 1px solid #1C3E95 ;
    
    --su-size-padding: 3px;
    --su-size-text: 20px;
    --su-color-bg: #fff;
    --su-color-text-normal: #1C3E95; 
    --su-color-progress-normal-bg: #fff;
    --su-color-progress-complete-bg: #fff;
    //--su-icon-handler: url(../../../assets/icon/arrow.svg);  
         
    .slideunlock-text {  
        font-style: normal;
        font-weight: 500;
        
    } 
}
</style>

<style lang="scss">
.slideunlock .slideunlock-handler { 
    background-size: 54px;
}
</style> -->